export class aceptarDialogo{
    textoSi: string;
    textoNo:string;
    encabezado: string;
}